import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';
import { User } from './user.ts';

export class Contribution extends Model<Schemas['contributions'], Models> {
    get createdAtDate() {
        return nullableDate(this.createdAt);
    }

    get lastViewedAtDate() {
        return nullableDate(this.lastViewedAt);
    }

    get lastActivityAtDate() {
        return nullableDate(this.lastActivityAt);
    }

    get readAtDate() {
        return nullableDate(this.readAt);
    }

    get finalizedAtDate() {
        return nullableDate(this.finalizedAt);
    }

    get paidAtDate() {
        return nullableDate(this.paidAt);
    }

    get deletedAtDate() {
        return nullableDate(this.deletedAt);
    }

    get isRead() {
        return (this.readAtDate || 0) >= (this.item?.updatedAtDate || 0);
    }

    get isUnread() {
        return !this.isRead;
    }

    get displayUser() {
        const user = this.user?.name ? this.user : undefined;

        if (!this.userDetails) {
            return user;
        }

        const displayUser = new User(
            {
                type: 'users',
                id: '',
                ...this.user?.identifier(),
                attributes: {
                    ...this.user?.attributes,
                    ...this.userDetails,
                },
            },
            this.store,
        );

        return displayUser.name ? displayUser : user;
    }
}
